var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPathfooterIcons2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64.237,
    height: 64.105,
    viewBox: "0 0 64.237 64.105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M64.2374 32.172C64.2374 14.402 49.8593 0 32.1187 0C14.3781 0 0 14.402 0 32.172C0 47.2526 10.3758 59.9204 24.3651 63.4015C24.3651 63.4015 24.3651 41.9996 24.3651 41.9996L17.7406 41.9996L17.7406 32.172L24.3651 32.172C24.3651 32.172 24.3651 27.9369 24.3651 27.9369C24.3651 16.9908 29.3083 11.9137 40.048 11.9137C42.0805 11.9137 45.5935 12.3158 47.0364 12.718C47.0364 12.718 47.0364 21.6156 47.0364 21.6156C46.2836 21.5402 44.9662 21.4899 43.3226 21.4899C38.0532 21.4899 36.0206 23.4881 36.0206 28.6783C36.0206 28.6783 36.0206 32.172 36.0206 32.172L46.5094 32.172L44.7027 41.9996L36.0081 41.9996C36.0081 41.9996 36.0081 64.1052 36.0081 64.1052C51.9169 62.1825 64.2374 48.6225 64.2374 32.172C64.2374 32.172 64.2374 32.172 64.2374 32.172C64.2374 32.172 64.2374 32.172 64.2374 32.172Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathfooterIcons2);
export default __webpack_public_path__ + "static/media/PathfooterIcons 2.f38140b6828f6ae52e31252f2415e6e5.svg";
export { ForwardRef as ReactComponent };